<script lang="ts">
	import { fly } from 'svelte/transition';
	import Crown from '$lib/IONOS/components/icons/Crown.svelte';
	import Heart from '$lib/IONOS/components/icons/Heart.svelte';
	import XMark from '$lib/IONOS/components/icons/XMark.svelte';
	import Info from '$lib/components/icons/Info.svelte';
	import Sparkles from '$lib/IONOS/components/icons/Sparkles.svelte';
	import Button, { ButtonType } from '$lib/IONOS/components/common/Button.svelte';
	import Link from '$lib/IONOS/components/common/Link.svelte';
	import { NotificationType, type SubscribableNotification } from '$lib/IONOS/stores/notifications';
	import { createEventDispatcher } from 'svelte';

	const dispatch = createEventDispatcher();

	export let notification: SubscribableNotification;
</script>


<div transition:fly={{ y: -200, duration: 50 }} class="notification-banner ease-in-out w-full h-[54px] sm:h-[60px] px-4 sm:px-5 flex items-center justify-start text-sm gap-2 {$notification.type}">
	<div id="notification-icon" class="pt-0.5 sm:pt-0">
		{#if $notification.type === NotificationType.FEEDBACK}
			<Heart />
		{:else if $notification.type === NotificationType.INFO}
			<Info className="size-5" />
		{:else if $notification.type === NotificationType.HEADSUP}
			<Crown />
		{:else if $notification.type === NotificationType.AI}
			<Sparkles />
		{/if}
	</div>
	<div class="grow md:flex flex-row gap-2.5 justify-between">
		<p class="max-md:inline">
			<span class="font-semibold">{$notification.title}</span>
		 	{$notification.message}
		</p>
		<div class="flex max-md:inline flex-row gap-2.5 items-center">
			{#each $notification.actions as action}
				<Link
					href={action.href ?? ''}
					on:click={action.handler}
					passive
					className="notification-action"
				>
					{action.label}
				</Link>
			{/each}
		</div>
	</div>
	{#if $notification.dismissible}
		<button class="notification-dismiss ml-auto" on:click={(e) => { $notification.dismiss?.(e) }}>
			<XMark />
		</button>
	{/if}
</div>
